<app-banner
  [loading]="gridLoading()"
  [epgType]="'single'"
  [bannerSlides]="bannerSlides()"></app-banner>
<app-channel-epg [playerIsReplaying]="false"></app-channel-epg>
